<script setup lang="ts">
import { RouterLink, type RouteLocationRaw } from 'vue-router';
defineProps<{ to: RouteLocationRaw }>();
</script>

<template>
  <nav class="back-button">
    <router-link v-bind="$props">
      <q-icon name="arrow_back" />
      {{ $t('community.back') }}
    </router-link>
  </nav>
</template>

<style scoped lang="scss">
.back-button {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  font-weight: bold;
  color: $secondary;

  .q-icon {
    font-size: 20px;
  }

  a {
    color: $secondary;
    text-decoration: none;
  }
}
</style>
